// removed by extract-text-webpack-plugin
module.exports = {"root":"button--root--2sUt4ZOs","yellow":"button--yellow--3j2L1LGp","red":"button--red--39xpVUON","gray":"button--gray--1LJbBOmy","white":"button--white--1DRHnDgO","no-padding":"button--no-padding--1DtiTiPZ","noPadding":"button--no-padding--1DtiTiPZ","disabled":"button--disabled--2ZAaWTpZ","w-full":"button--w-full--2sM-J8do","wFull":"button--w-full--2sM-J8do"};


//////////////////
// WEBPACK FOOTER
// ./components/button/styles.css
// module id = ./components/button/styles.css
// module chunks = 0